import { createApiClient, CredentialsManager } from "http-with-fetch";
import { OBVisitor } from "./api-visitor";

class SimpleManager implements CredentialsManager {
  async attach(init: RequestInit, url: string) {
    init.credentials = "include";
    init.headers = new Headers(init.headers ?? {});
    init.headers.set("Accept", "application/json");
    return { init, url };
  }
  async isValid() {
    return true;
  }
  async refresh() {}
}

/**
 * `SimpleApi` is used when the API call can be made without any session attached to it.
 */
export const SimpleApi = createApiClient(
  { credentials: new SimpleManager(), visitor: OBVisitor },
  false
);
